import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { Box, MenuItem } from '@mui/material';
import { BREAKPOINTS } from '@src/styles/config';

const StyledSrtProjectButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 8px;
  margin-left: auto;
  background: linear-gradient(
    132.31deg,
    rgba(244, 139, 113, 1) 15.23%,
    rgba(241, 65, 77, 1) 42.62%,
    rgba(86, 62, 250, 1) 99.91%
  );
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
  }

  .srt-project-text {
    color: white;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    white-space: nowrap;
  }
`;

const StyledToolBar = styled('div')`
  display: flex;
  justify-content: start;
  align-items: center;
  background: ${COLOR.secondary[40]};
  border-radius: 8px;
  padding: 8px;
  gap: 16px;

  .border-horizontal {
    display: flex;
    align-items: center;
    border-left: 1px solid ${COLOR.light};
    height: 28px;

    .icon-content {
      display: flex;
      gap: 4px;
      text-transform: lowercase;
    }
  }

  .speed {
    display: flex;
    align-items: center;
    border-left: 1px solid ${COLOR.light};
    height: 28px;
  }

  .title {
    color: ${COLOR.darkBlue};
    font-weight: 500;
  }

  .character-default {
    font-size: 14px;
    font-weight: 500;
    color: ${COLOR.darkBlue};
    text-transform: lowercase;
  }

  .character-blue {
    color: ${COLOR.info};
  }

  .convert-button {
    margin-left: auto;
    padding: 8px 22px;
  }

  @media only screen and (min-width: ${BREAKPOINTS.SM}px) {
    .speed {
      padding-left: 16px;
    }

    .border-horizontal {
      padding-right: 16px;
      padding-left: 16px;
      /* margin-right: 16px;
      margin-left: 16px; */
    }
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .speed {
      padding-left: 8px;
    }

    .border-horizontal {
      padding-left: 8px;
      margin-left: 8px;
    }
  }
`;

const StyledSelectionButton = styled('div')`
  width: auto;

  .custom-button {
    padding: 0px;
    display: flex;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.text};
    gap: 8px;
    width: 92px;
  }

  .icon-content {
    display: flex;
    gap: 4px;
    text-transform: lowercase;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  cursor: pointer;
  padding: 6px 16px;
  border-radius: 4px;
  display: flex;
  gap: 8px;

  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && COLOR.primary40};

  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? COLOR.primary40 : TRANSPARENT_COLOR.dark};
  }
`;

const StyledMenu = styled('div')`
  margin: 8px;
`;

export {
  StyledToolBar,
  StyledSelectionButton,
  StyledMenuItem,
  StyledMenu,
  StyledSrtProjectButton,
};
